module.exports = __webpack_public_path__ + "static/media/agent.ff885c88.jpg";